import superagent from 'superagent'

// DEDUPLICATION CONFIG
const DEDUPLICATION_WINDOW = 2000; // 3 seconds
const valueRequestCache = new Map();

// export const fetchGetUnitDetails = (payload) => (dispatch, getState, token) => {
//     Object.keys(payload).forEach((key) => {
//         if (payload[key] === undefined || payload[key] === null || payload[key] === '') {
//             delete payload[key];
//         }
//     });

//     const params = new URLSearchParams(payload).toString();

//     return new Promise((resolve, reject) => {
//         superagent
//             .get(`${__API_URI__}/HuntPlanner/GetUnitDetails/list?${params}`)
//             .set('Content-Type', 'application/json')
//             .set('Authorization', `Bearer ${token}`)
//             .set('Platform', 'Web')
//             .set('Version', `${__version__}`)
//             .end((err, res) => {
//                 if (res) {
//                     resolve(res.body)
//                 } else if (err) {
//                     reject(err)
//                 }
//             })
//     })
// }

export const fetchGetUnitDetails = (payload) => (dispatch, getState, token) => {
    Object.keys(payload).forEach((key) => {
        if (payload[key] === undefined || payload[key] === null || payload[key] === '') {
            delete payload[key];
        }
    });

    const params = new URLSearchParams(payload).toString();
    const cacheKey = params;
    const now = Date.now();
    const existing = valueRequestCache.get(cacheKey);

    if (existing && now - existing.timestamp < DEDUPLICATION_WINDOW) {
        return existing.promise;
    }
    const request = new Promise((resolve, reject) => {
        superagent
            .get(`${__API_URI__}/HuntPlanner/GetUnitDetails/list?${params}`)
            .set('Content-Type', 'application/json')
            .set('Authorization', `Bearer ${token}`)
            .set('Platform', 'Web')
            .set('Version', `${__version__}`)
            .end((err, res) => {
                valueRequestCache.delete(cacheKey);
                if (res) resolve(res.body);
                else reject(err);
            });
    });
    valueRequestCache.set(cacheKey, { timestamp: now, promise: request });
    return request;
}

export const fetchGetHuntDetails = (payload) => (dispatch, getState, token) => {
    Object.keys(payload).forEach((key) => {
        if (payload[key] === undefined || payload[key] === null || payload[key] === '') {
            delete payload[key];
        }
    });

    const params = new URLSearchParams(payload).toString();

    return new Promise((resolve, reject) => {
        superagent
            .get(`${__API_URI__}/HuntPlanner/GetHuntDetails?${params}`)
            .set('Content-Type', 'application/json')
            .set('Authorization', `Bearer ${token}`)
            .set('Platform', 'Web')
            .set('Version', `${__version__}`)
            .end((err, res) => {
                if (res) {
                    resolve(res.body)
                } else if (err) {
                    reject(err)
                }
            })
    })
}

// A unit's climate normals (API-3847 GetUnitClimate?validGeo=<unit uuid>), kept per unit for the session: unit details
// and hunt details both ask for it, and the normals don't change. A unit without them resolves null.
const unitClimateCache = new Map();

export const fetchGetUnitClimate = (payload) => (dispatch, getState, token) => {
    Object.keys(payload).forEach((key) => {
        if (payload[key] === undefined || payload[key] === null || payload[key] === '') {
            delete payload[key];
        }
    });

    const params = new URLSearchParams(payload).toString();
    if (unitClimateCache.has(params)) return unitClimateCache.get(params);

    const request = new Promise((resolve) => {
        superagent
            .get(`${__API_URI__}/HuntPlanner/GetUnitClimate?${params}`)
            .set('Content-Type', 'application/json')
            .set('Authorization', `Bearer ${token}`)
            .set('Platform', 'Web')
            .set('Version', `${__version__}`)
            .end((err, res) => {
                if (err || !res) {
                    unitClimateCache.delete(params);
                    resolve(null);
                } else resolve(res.body || null);
            });
    });
    unitClimateCache.set(params, request);
    return request;
}

// What's happening in a unit now (API-3864 GetUnitAlerts?validGeo=<unit uuid>): fires, closures, drought, unusual
// weather, agency news and forum threads. Kept per unit for the session, as the climate is; the sources refresh daily
// at most. An error resolves null, so the card renders without them.
const unitAlertsCache = new Map();

export const fetchGetUnitAlerts = (payload) => (dispatch, getState, token) => {
    Object.keys(payload).forEach((key) => {
        if (payload[key] === undefined || payload[key] === null || payload[key] === '') {
            delete payload[key];
        }
    });

    const params = new URLSearchParams(payload).toString();
    if (unitAlertsCache.has(params)) return unitAlertsCache.get(params);

    const request = new Promise((resolve) => {
        superagent
            .get(`${__API_URI__}/HuntPlanner/GetUnitAlerts?${params}`)
            .set('Content-Type', 'application/json')
            .set('Authorization', `Bearer ${token}`)
            .set('Platform', 'Web')
            .set('Version', `${__version__}`)
            .end((err, res) => {
                if (err || !res) {
                    unitAlertsCache.delete(params);
                    resolve(null);
                } else resolve(res.body || null);
            });
    });
    unitAlertsCache.set(params, request);
    return request;
}
